var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-page-content" },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "title-wrapper" }, [
          _c("h1", { staticClass: "main-title" }, [
            _vm._v(_vm._s(_vm.$t("voiceagent.phoneNumbers"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title-description" }, [
            _vm._v(_vm._s(_vm.$t("voiceagent.phoneNumbersDescription"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _c(
          "div",
          { staticClass: "table-wrapper" },
          [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("a-input-search", {
                    staticClass: "search-input",
                    staticStyle: { width: "300px", margin: "unset !important" },
                    attrs: { placeholder: "Ara" },
                    on: { input: _vm.onSearch },
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "PermissionController",
                    { attrs: { permissions: ["voice-agent.create"] } },
                    [
                      _c(
                        "a-dropdown",
                        { attrs: { trigger: ["click"] } },
                        [
                          _c("SupsisButton", { attrs: { primary: "" } }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("voiceagent.addNewNumber")) +
                                "\n                                "
                            ),
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  "font-size": "16px",
                                  "margin-left": "5px",
                                },
                              },
                              [_vm._v("arrow_drop_down")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-menu",
                            {
                              staticClass: "number-dropdown-menu",
                              attrs: { slot: "overlay" },
                              slot: "overlay",
                            },
                            [
                              _c(
                                "a-menu-item",
                                { on: { click: _vm.openNetGSM } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("phone"),
                                  ]),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t("voiceagent.buyNumberFromNetGSM")
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                { on: { click: _vm.openVerimor } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("phone"),
                                  ]),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "voiceagent.buyNumberFromVerimor"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                { on: { click: _vm.showRegistrationForm } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add_circle"),
                                  ]),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t("voiceagent.createNumberRequest")
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                { on: { click: _vm.showImportSipForm } },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("phone_forwarded"),
                                  ]),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "voiceagent.addNumberWithSipInfo"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "a-spin",
              { attrs: { spinning: _vm.loading } },
              [
                _c("SupsisTable", {
                  attrs: {
                    columns: _vm.getCols(),
                    rows: _vm.paginatedPhoneNumbers,
                    "top-pagination": true,
                    "empty-data-bordered": "",
                    "bottom-pagination": false,
                    "pagination-cursor": _vm.pagination,
                    options: {
                      rowStyleOption: _vm.rowStyleOption,
                      clipboardOption: _vm.clipboardOption,
                      fixedHeader: true,
                      id: "phone-numbers-table",
                      borderX: true,
                      borderY: true,
                    },
                  },
                  on: {
                    "cursor-changed": function (cursor) {
                      return (_vm.pagination = cursor)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("voiceagent.makeCall"),
            footer: null,
            width: "500px",
          },
          on: {
            cancel: function ($event) {
              _vm.showCallModal = false
            },
          },
          model: {
            value: _vm.showCallModal,
            callback: function ($$v) {
              _vm.showCallModal = $$v
            },
            expression: "showCallModal",
          },
        },
        [
          _c(
            "a-form",
            {
              attrs: { form: _vm.callForm, layout: "vertical" },
              on: { submit: _vm.handleCallSubmit },
            },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("voiceagent.numberToCall") } },
                [
                  _c(
                    "a-radio-group",
                    {
                      staticClass: "number-format-radio-group",
                      attrs: { size: "small", "button-style": "solid" },
                      model: {
                        value: _vm.callNumberFormat,
                        callback: function ($$v) {
                          _vm.callNumberFormat = $$v
                        },
                        expression: "callNumberFormat",
                      },
                    },
                    [
                      _c("a-radio-button", { attrs: { value: "e164" } }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.formatToE164"))),
                      ]),
                      _vm._v(" "),
                      _c("a-radio-button", { attrs: { value: "raw" } }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.keepRawInput"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: [
                          "to_number",
                          {
                            rules: [
                              {
                                required: true,
                                message: "Lütfen aranacak numarayı girin!",
                              },
                            ],
                          },
                        ],
                        expression:
                          "[\n                        'to_number',\n                        {\n                            rules: [{ required: true, message: 'Lütfen aranacak numarayı girin!' }]\n                        }\n                    ]",
                      },
                    ],
                    attrs: { placeholder: "+905xxxxxxxxx" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "number-format-info" }, [
                    _vm._v(_vm._s(_vm.$t("voiceagent.numberE164Format"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button-container" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "mr-2",
                      on: {
                        click: function ($event) {
                          _vm.showCallModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.cancel")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        "html-type": "submit",
                        loading: _vm.submittingCall,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.call")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("voiceagent.numberAdditionRequest"),
            footer: null,
            width: "800px",
            destroyOnClose: true,
          },
          on: {
            cancel: function ($event) {
              _vm.showIframeModal = false
            },
          },
          model: {
            value: _vm.showIframeModal,
            callback: function ($$v) {
              _vm.showIframeModal = $$v
            },
            expression: "showIframeModal",
          },
        },
        [
          _vm.showIframeModal
            ? _c("iframe", {
                staticStyle: { width: "100%", height: "600px", border: "none" },
                attrs: {
                  src: "https://form.supsis.ai/form/67f927997fe5efaf7e643a73/5d14ee322d95ad001ebdf213",
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("voiceagent.addNumberWithSipInfo"),
            footer: null,
            width: "600px",
          },
          on: {
            cancel: function ($event) {
              _vm.showSipImportModal = false
            },
          },
          model: {
            value: _vm.showSipImportModal,
            callback: function ($$v) {
              _vm.showSipImportModal = $$v
            },
            expression: "showSipImportModal",
          },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.submittingSip } },
            [
              _c(
                "a-form",
                {
                  attrs: { form: _vm.sipImportForm, layout: "vertical" },
                  on: { submit: _vm.handleSipImportSubmit },
                },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("voiceagent.phoneNumber") } },
                    [
                      _c(
                        "a-radio-group",
                        {
                          staticClass: "number-format-radio-group",
                          attrs: { size: "small", "button-style": "solid" },
                          model: {
                            value: _vm.sipNumberFormat,
                            callback: function ($$v) {
                              _vm.sipNumberFormat = $$v
                            },
                            expression: "sipNumberFormat",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "e164" } }, [
                            _vm._v(_vm._s(_vm.$t("voiceagent.formatToE164"))),
                          ]),
                          _vm._v(" "),
                          _c("a-radio-button", { attrs: { value: "raw" } }, [
                            _vm._v(_vm._s(_vm.$t("voiceagent.keepRawInput"))),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "phone_number",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: "Lütfen telefon numarasını girin!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'phone_number',\n                            {\n                                rules: [{ required: true, message: 'Lütfen telefon numarasını girin!' }]\n                            }\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "+905xxxxxxxxx" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "number-format-info" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.e164FormatExample"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("voiceagent.sipTrunkUri") } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "termination_uri",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Lütfen SIP Trunk URI bilgisini girin!",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'termination_uri',\n                            {\n                                rules: [{ required: true, message: 'Lütfen SIP Trunk URI bilgisini girin!' }]\n                            }\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "ornek.pstn.twilio.com" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "number-format-info" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.sipTrunkUriInfo"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("voiceagent.sipTrunkUsername") } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["sip_trunk_auth_username", {}],
                            expression:
                              "[\n                            'sip_trunk_auth_username',\n                            {}\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "Kullanıcı adı (isteğe bağlı)" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("voiceagent.sipTrunkPassword") } },
                    [
                      _c("a-input-password", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["sip_trunk_auth_password", {}],
                            expression:
                              "[\n                            'sip_trunk_auth_password',\n                            {}\n                        ]",
                          },
                        ],
                        attrs: { placeholder: "Şifre (isteğe bağlı)" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("voiceagent.nickname") } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["nickname", {}],
                            expression:
                              "[\n                            'nickname',\n                            {}\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: "Numara takma adı (isteğe bağlı)",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-container" },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "mr-2",
                          on: {
                            click: function ($event) {
                              _vm.showSipImportModal = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("voiceagent.cancel")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            "html-type": "submit",
                            loading: _vm.submittingSip,
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("voiceagent.add")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }